export default __webpack_public_path__ + "static/media/IMG_1986.91284766.JPG";